import React, { FC } from 'react';
import { hasFlag } from 'country-flag-icons';
import * as flags from 'country-flag-icons/react/3x2';

import { CommunityNode, CityNode } from 'generated/types';
import { GlobeIcon } from 'components/icons/v2/Globe';

type CountryCodeFlagCommunity = Pick<CommunityNode, 'locationGlobal'> & {
  location?: Pick<CityNode, 'id' | 'countryCode'> | null;
}

type SpaceCountryFlagProps = {
  community: CountryCodeFlagCommunity;
  className?: string
  wrapperClassName?: string
}

export const SpaceCountryFlag: FC<SpaceCountryFlagProps> = (props) => {
  const icon = () => {
    const code = props.community.location?.countryCode?.toUpperCase();
    if (!code || !hasFlag(code) || !(code in flags)) {
      return null;
    }
    return flags[code as keyof typeof flags];
  }
  const FlagComponent = icon()
  const className = `${props.className} w-auto h-[15px] absolute top-0 left-1/2 -translate-x-1/2`

  return (
    <div className={`${props.wrapperClassName} relative overflow-hidden w-[16px] h-[16px] rounded-full border-[0.33px] border-black/10 box-border`}>
      {props.community.locationGlobal ? (
        <>
        <GlobeIcon className={className}/>
        </>
      ) : (
        FlagComponent && <FlagComponent className={className} />
      )}
    </div>
  );
};